import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../api/axios";

const AddShiftModal = ({ showModal, onClose, onShiftAdded, editShift }) => {
  const [code, setCode] = useState("");
  const [shiftName, setShiftName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editShift) {
      setCode(editShift.code || "");
      setShiftName(editShift.name || "");
      setStartTime(editShift.start_time?.slice(0, 5) || "");
      setEndTime(editShift.end_time?.slice(0, 5) || "");
    } else {
      setCode("");
      setShiftName("");
      setStartTime("");
      setEndTime("");
    }
  }, [editShift]);

  const handleSave = async () => {
    // Validation
    if (!code || !shiftName || !startTime || !endTime) {
      Swal.fire({
        title: "Error!",
        text: "Please fill in all fields",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return; // Modal stays open
    }

    try {
      const newShift = {
        code,
        name: shiftName,
        start_time: startTime,
        end_time: endTime,
      };
      setLoading(true);

      const res = editShift
        ? await api.put(`/hrms/shifts/${editShift.id}`, newShift)
        : await api.post("/hrms/shifts", newShift);

      Swal.fire({
        title: "Success!",
        text: editShift
          ? "Shift updated successfully!"
          : "Shift added successfully!",
        icon: "success",
        timer: 1200,
        showConfirmButton: false,
      });

      // Reset form
      setCode("");
      setShiftName("");
      setStartTime("");
      setEndTime("");

      // Callback to refresh data
      if (onShiftAdded) onShiftAdded();

      // Close modal only after successful save
      onClose();
    } catch (error) {
      console.error("Error saving shift:", error);
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || "Failed to save shift",
        icon: "error",
        confirmButtonText: "OK",
      });
      // Modal stays open on error
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-3">
          <div className="modal-header bg-dark text-white">
            <h5 className="modal-title">
              {editShift ? "Edit Shift" : "Add New Shift"}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Shift Code</label>
              <input
                type="text"
                className="form-control"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Shift Name</label>
              <input
                type="text"
                className="form-control"
                value={shiftName}
                onChange={(e) => setShiftName(e.target.value)}
                required
              />
            </div>
            <div className="d-flex gap-3">
              <div className="mb-3 flex-fill">
                <label className="form-label">Start Time</label>
                <input
                  type="time"
                  className="form-control"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3 flex-fill">
                <label className="form-label">End Time</label>
                <input
                  type="time"
                  className="form-control"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary d-flex align-items-center gap-2 py-2 px-3 mt-4"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
              onClick={handleSave}
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editShift
                ? "Update Shift"
                : "Save Shift"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddShiftModal;
